<form [formGroup]="newsForm" class="row">
  <div class="input-wrapper col-md-6">
    <mat-form-field appearance="outline">
      <mat-label>Default news status</mat-label>
      <mat-select formControlName="defaultNewsStatus">
        <mat-option *ngFor="let status of availableNewsStatus" [value]="status">
          {{ status }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="input-wrapper col-md-6">
    <mat-form-field appearance="outline">
      <mat-label>Default news language</mat-label>
      <mat-select formControlName="defaultNewsLanguage">
        <mat-option
          *ngFor="let language of availableNewsLanguage"
          [value]="language"
        >
          {{ language }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="input-wrapper col-md-6">
    <mat-form-field appearance="outline">
      <mat-label>News expiration (days)</mat-label>
      <input
        matInput
        type="number"
        formControlName="endDateDaysGap"
        placeholder="i.e. 12"
      />
    </mat-form-field>
  </div>

  <div class="input-wrapper col-md-6">
    <mat-form-field appearance="outline">
      <mat-label>Custom RSS fields</mat-label>
      <mat-chip-list #chipList formControlName="newsCustomFieldsItem">
        <mat-chip
          *ngFor="let customField of newsForm.get('newsCustomFieldsItem').value"
          (removed)="remove(customField)"
          [removable]="true"
        >
          {{ customField }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
        <input
          placeholder="ie. Content"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)"
        />
      </mat-chip-list>
    </mat-form-field>
  </div>

  <div class="input-wrapper col-md-6">
    <mat-form-field appearance="outline">
      <mat-label>Type of RSS Feed (optional)</mat-label>
      <mat-select formControlName="newsRssFeedType">
        <mat-option
          *ngFor="let rssFeedType of availableNewsRssFeedTypes"
          [value]="rssFeedType"
        >
          {{ rssFeedType }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="input-wrapper col-md-6">
    <mat-slide-toggle
      color="primary"
      formControlName="newsLanguageUrlInterpretation"
    >
      Detect language from URL
    </mat-slide-toggle>
  </div>

  <div class="input-wrapper col-md-6">
    <mat-slide-toggle color="primary" formControlName="newsWordPressFeed">
      RSS feed comes from Wordpress
    </mat-slide-toggle>
  </div>
</form>
